var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgTips(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12.5 1C18.8 1 24 6.2 24 12.5S18.8 24 12.5 24 1 18.8 1 12.5 6.2 1 12.5 1m0-1C5.6 0 0 5.6 0 12.5S5.6 25 12.5 25 25 19.4 25 12.5 19.4 0 12.5 0z",
    fill: "#e1087e"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M12.5 17.3c-7 0-8.5-2.2-8.5-3 0-.2 0-1 2.9-1.8.7-3.6 2-6.1 3.2-6.1.7 0 1.1.6 1.4 1 .1.1.2.3.3.4.2.2.6.3.7.3.1 0 .4-.1.7-.3.1-.1.2-.3.3-.4.3-.5.8-1 1.4-1 1.2 0 2.4 2.5 3.2 6.1 2.9.8 2.9 1.5 2.9 1.8 0 .8-1.5 3-8.5 3zM5 14.4c.2.4 1.8 1.9 7.5 1.9 5.6 0 7.3-1.5 7.5-1.9-.3-.2-1.4-.7-2.4-.9l-.3-.1-.1-.4c-.7-4-1.9-5.5-2.3-5.6-.1 0-.4.4-.6.6-.1.2-.3.4-.4.5-.5.5-1.2.6-1.4.6-.2 0-.9-.2-1.4-.6-.1-.1-.3-.3-.4-.5-.2-.3-.5-.6-.6-.6-.3.1-1.5 1.6-2.3 5.6l-.1.3-.3.1c-1 .3-2.1.7-2.4 1z",
    fill: "#fff"
  })));
}
export default SvgTips;